<template>
  <f7-popup class="AddContactGroup">
		<page-nav-bar currentServiceName="MoneyRoad" subNavTitle="New Group" :closePopup="true"></page-nav-bar>
    <div class="layoutSubtitle"/>
    <!-- Group name -->
    <f7-list form>
      <f7-list-item>
        <f7-label>Group name</f7-label>
        <f7-input name="label" type="text" placeholder="Group name" v-model="label"></f7-input>
      </f7-list-item>
      <li class=''>
        <a class=" smart-select smart-select-init"
          data-open-in="page"
          data-searchbar="true"
          data-searchbar-placeholder="Search contact"
          data-page-title="My Contacts"
          data-back-text="OK">
          <select name="Debtor Information" multiple v-model="selected" v-on:change="changeItem()">
            <optgroup v-for="(group, key) in this.contactSelectionList" :label="key">
              <option v-for="(contact, index) in group" :value="contact.id">{{contact.label}}</option>
            </optgroup>
          </select>
          <div class="test-content">
            <div class="test-inner">
              <div class="test-title subtitleDebtorList">My contacts</div>
              <div class="test-after"><span href="#" class="button active">{{this.selected.length}} selected | Edit</span></div>
            </div>
          </div>
        </a>
      </li>
    </f7-list>
    <div class="test-content">
      <div class="test-inner">
        <div class="test-title subtitleDebtorList" style="font-size:17px; color:black">My contacts</div>
        <div class="test-after" style=""><span href="#" class="button active">Select</span></div>
      </div>
    </div>
    <div style="color:white;background-color:#12bcf1;padding-left:16px;font-size:15px;padding:4px 16px;">Contacts in this group</div>
    <!-- Selected contacts list -->
    <f7-list>
      <f7-list-item inner title="Arianne Poissonnier Home"></f7-list-item>
      <f7-list-item title="Clemence Barrientos Compony"></f7-list-item>
      <f7-list-item title="Didier Matin Company"></f7-list-item>
      <f7-list-item title="Norris Lalonde Company"></f7-list-item>
    </f7-list>
    <!-- Button -->
    <f7-button icon-f7="add_round" class="blueConfirmationButton" @click="addContactGroup">Create</f7-button>
  </f7-popup>
</template>

<script>
import {errorMessageAlert} from '@/helpers/alert'
import pageNavBar from '@/components/common/pageNavBar.vue'

export default {
  name: 'AddContactGroup',
  components: {
    'page-nav-bar': pageNavBar
  },
  data: () => {
    return {
      contactSelectionList: [],
      selected: [],
      alias: '',
      username: '',
      iban: '',
      label: ''
    }
  },
  created () {
    this.setContacts()
  },
  mounted () {
  },
  beforeDestroy () {
  },
  methods: {
    changeItem () {
      this.selectedDebtors = {}
      for (var i = 0; i < this.selected.length; i++) {
        this.selectedDebtors[this.selected[i]] = this.contactsObject[this.selected[i]]
      }
    },
    setContacts: function () {
      var contactList = {}
      for (var j = 0; j < this.$engine.contacts.get().length; j++) {
        var firstLetter = this.$engine.contacts.get(j).login.substr(0, 1).toUpperCase()
        if (!contactList.hasOwnProperty(firstLetter)) {
          contactList[firstLetter] = []
        }
        contactList[firstLetter].push({label: this.$engine.contacts.get(j).label, iban: this.$engine.contacts.get(j).iban, login: this.$engine.contacts.get(j).login, name: this.$engine.contacts.get(j).name, id: this.$engine.contacts.get(j).id})
        contactList[firstLetter].sort()
      }
      this.contactSelectionList = this.orderKeys(contactList)
    },
    orderKeys: function (obj, expected) {
      var keys = Object.keys(obj).sort(function keyOrder (k1, k2) {
        if (k1 < k2) return -1
        else if (k1 > k2) return +1
        else return 0
      })
      var i
      var after = {}
      for (i = 0; i < keys.length; i++) {
        after[keys[i]] = obj[keys[i]]
        delete obj[keys[i]]
      }
      for (i = 0; i < keys.length; i++) {
        obj[keys[i]] = after[keys[i]]
      }
      return obj
    },
    addContactGroup () {
      let that = this
      this.$engine.contacts
        .create({login: this.alias, name: this.username, iban: this.iban, label: this.label})
        .then(() => {
          that.$bus.$emit('refresh-cache-contacts')
          that.$f7.alert('Contact correctly added', 'Success', function () {
            that.$f7.closeModal()
          })
        })
        .catch(err => {
          errorMessageAlert(err, this)
        })
    }
  }
}
</script>
